import React, { useState, useEffect } from "react";
import api from "../Api/api";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";

const ServiceAreaSections = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/service-area-sections")
      .then((res) => {
        setSections(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching service area sections:", err);
        setLoading(false);
      });
  }, []);

  if (loading || sections.length === 0) {
    return null;
  }

  const localExpertsSection = sections.find((s) => s.section_key === "local_experts");
  const serviceAreasSection = sections.find((s) => s.section_key === "service_areas");

  return (
    <>
      {/* Section 1: Local Cleaning Experts */}
      {localExpertsSection && (
        <section className="local-experts-section py-5" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="text-center mb-4">
                  <h2 className="fw-bold" style={{ color: "#001070" }}>
                    <FaMapMarkerAlt style={{ color: "#0a62a9", marginRight: "10px" }} />
                    {localExpertsSection.title}
                  </h2>
                </div>
                <div
                  className="text-center"
                  style={{
                    fontSize: "1.1rem",
                    lineHeight: "1.8",
                    color: "#555",
                    maxWidth: "900px",
                    margin: "0 auto"
                  }}
                  dangerouslySetInnerHTML={{ __html: localExpertsSection.description }}
                />
                <div className="text-center mt-4">
                  <a
                    href="tel:0406958557"
                    className="btn btn-primary px-5 py-3"
                    style={{
                      borderRadius: "30px",
                      fontSize: "1.1rem",
                      backgroundColor: "#0a62a9",
                      border: "none"
                    }}
                  >
                    <FaPhoneAlt className="me-2" />
                    Get in Touch
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Section 2: Service Areas We Cover */}
      {serviceAreasSection && (
        <section className="service-areas-section py-5" style={{ backgroundColor: "#ffffff" }}>
          <div className="container">
            <div className="text-center mb-4">
              <h2 className="fw-bold" style={{ color: "#001070" }}>
                {serviceAreasSection.title}
              </h2>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div
                  className="mb-4"
                  style={{
                    fontSize: "1.1rem",
                    lineHeight: "1.8",
                    color: "#555",
                    textAlign: "center"
                  }}
                  dangerouslySetInnerHTML={{ __html: serviceAreasSection.description }}
                />

                {/* Suburbs List in Pills/Badges */}
                {serviceAreasSection.content && (
                  <>
                    <div className="suburbs-list mt-4 mb-4">
                      <div className="d-flex flex-wrap justify-content-center gap-2 gap-md-3">
                        {serviceAreasSection.content.split('\n\n')[0].split(',').map((suburb, index) => (
                          <span
                            key={index}
                            className="badge"
                            style={{
                              backgroundColor: "#e3f2fd",
                              color: "#0a62a9",
                              fontSize: "0.75rem",
                              fontWeight: "500",
                              borderRadius: "12px",
                              border: "1px solid #0a62a9",
                              display: "inline-block",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              lineHeight: "1.4",
                              padding: "6px 12px",
                              maxWidth: "100%",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }}
                          >
                            {suburb.trim()}
                          </span>
                        ))}
                      </div>
                    </div>

                    {/* Bottom Content */}
                    <div
                      className="text-center mt-4"
                      style={{
                        fontSize: "1.05rem",
                        lineHeight: "1.8",
                        color: "#555"
                      }}
                      dangerouslySetInnerHTML={{
                        __html: serviceAreasSection.content.split('\n\n').slice(1).join('\n\n')
                      }}
                    />
                  </>
                )}

                <div className="text-center mt-5">
                  <div
                    className="p-4"
                    style={{
                      backgroundColor: "#e3f2fd",
                      borderRadius: "15px",
                      border: "2px solid #0a62a9"
                    }}
                  >
                    <h5 className="fw-bold" style={{ color: "#001070" }}>
                      Don't see your suburb listed?
                    </h5>
                    <p className="mb-3" style={{ color: "#555" }}>
                      Reach out to us — we cover more areas than listed above!
                    </p>
                    <a
                      href="/contact-us"
                      className="btn btn-primary px-5 py-2"
                      style={{
                        borderRadius: "30px",
                        backgroundColor: "#0a62a9",
                        border: "none"
                      }}
                    >
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ServiceAreaSections;
